export default "__VITE_ASSET__C198$cIz__"